import { Tags } from "@/enum/tags";
import { apiSlice } from "./http";
import { IFileDate, IFileUploadResponse } from "@/@types/tax-file";

export const spedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadSpedFiles: builder.mutation<IFileUploadResponse, { params: IFileDate; body: FormData }>({
      query: ({ params, body }) => {
        const urlParams = new URLSearchParams(params as unknown as Record<string, string>);
        return {
          url: `/sped/upload?${urlParams.toString()}`,
          method: "POST",
          body,
        };
      },
     
      invalidatesTags: [Tags.TAX_INTEGRATION],
    }),
    
  }),
  overrideExisting: true,
  
});

export const { useUploadSpedFilesMutation } = spedApi;

export const {
  endpoints: {
    uploadSpedFiles: { select: selectUploadSpedFiles },
  },
} = spedApi;
